import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IProductionDetailsSummary } from '../../../..';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';

export const getMarineHullSections = (
  data: IProductionDetailsSummary
): IDynamicFormWidgetSection[] => [
  {
    sectionTitle: 'Information',
    inputs: {
      vesselName: {
        name: 'vesselName',
        title: 'Vessel Name',
        placeholder: 'Vessel Name',
        type: FormFieldType.text,
        value: data?.MarineHull?.VesselName || '',
        required: true,
      },
      connectionPort: {
        name: 'connectionPort',
        title: 'Connection Port',
        placeholder: 'Connection Port',
        type: FormFieldType.text,
        value: data?.MarineHull?.ConnectionPort || '',
        required: true,
      },
      territorialWaters: {
        name: 'territorialWaters',
        title: 'Territorial Waters',
        placeholder: 'Territorial Waters',
        type: FormFieldType.text,
        value: data?.MarineHull?.TerritorialWaters || '',
        required: true,
      },
    },
  },
  {
    sectionTitle: 'Body Details',
    inputs: {
      usage: {
        name: 'usage',
        title: 'Usage',
        placeholder: 'Usage',
        type: FormFieldType.text,
        value: data?.MarineHull?.Usage || '',
        required: true,
      },
      builder: {
        name: 'builder',
        title: 'Builder',
        placeholder: 'Builder',
        type: FormFieldType.text,
        value: data?.MarineHull?.Builder || '',
        required: true,
      },
      constructionYear: {
        name: 'constructionYear',
        title: 'Year of Construction',
        placeholder: 'Year of Construction',
        type: FormFieldType.text,
        value: data?.MarineHull?.ConstructionYear || '',
        required: true,
      },
      registryPort: {
        name: 'registryPort',
        title: 'Port of Registery & Number',
        placeholder: 'Port of Registery & Number',
        type: FormFieldType.text,
        value: data?.MarineHull?.RegisteryPort || '',
        required: true,
      },
      length: {
        name: 'length',
        title: 'Length',
        placeholder: 'Length',
        type: FormFieldType.text,
        value: data?.MarineHull?.Length || '',
        required: false,
      },
      weight: {
        name: 'weight',
        title: 'Weight',
        placeholder: 'Weight',
        type: FormFieldType.text,
        value: data?.MarineHull?.Weight || '',
        required: false,
      },
      height: {
        name: 'height',
        title: 'Height',
        placeholder: 'Height',
        type: FormFieldType.text,
        value: data?.MarineHull?.Height || '',
        required: false,
      },
    },
  },
  {
    sectionTitle: 'Engine Details',
    inputs: {
      engineType: {
        name: 'engineType',
        title: 'Type',
        placeholder: 'Type',
        type: FormFieldType.text,
        value: data?.MarineHull?.EngineType || '',
        required: true,
      },
      engineNumber: {
        name: 'engineNumber',
        title: 'Engine Number',
        placeholder: 'Engine Number',
        type: FormFieldType.text,
        value: data?.MarineHull?.EngineNumber || '',
        required: false,
      },
      engineYearBuilt: {
        name: 'engineYearBuilt',
        title: 'Year Built',
        placeholder: 'Year Built',
        type: FormFieldType.text,
        value: data?.MarineHull?.EngineYearBuilt || '',
        required: true,
      },
      engineHorsePower: {
        name: 'engineHorsePower',
        title: 'Horse Power',
        placeholder: 'Horse Power',
        type: FormFieldType.text,
        value: data?.MarineHull?.EngineHorsePower || '',
        required: true,
      },
      engineMaxDesignedSpeed: {
        name: 'engineMaxDesignedSpeed',
        title: 'Max. Designed Speed',
        placeholder: 'Max. Designed Speed',
        type: FormFieldType.text,
        value: data?.MarineHull?.EngineMaxDesignedSpeed || '',
        required: false,
      },
      engineFuel: {
        name: 'engineFuel',
        title: 'Fuel',
        placeholder: 'Fuel',
        type: FormFieldType.text,
        value: data?.MarineHull?.EngineFuel || '',
        required: false,
      },
      remarks: {
        name: 'remarks',
        title: 'Remarks',
        placeholder: 'Remarks',
        type: FormFieldType.textArea,
        value: data?.MarineHull?.Remarks || '',
        required: false,
      },
    },
  },
];
